import { render, staticRenderFns } from "./canales.vue?vue&type=template&id=bfe497ee"
import script from "./canales.vue?vue&type=script&lang=js"
export * from "./canales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports